"use client";

import { useLocation } from "react-router-dom";

import { useEffect, useState, useCallback } from "react";
import { showToast } from "../../../components/custom/custom-toast";
import DateInputCustom from "../../../components/custom/date-input/date-input-custom";
import { useStoreOptions } from "../../../hooks/use-store-options";
import { ServiceMapService } from "../services/service-map-service";
import { ServiceAddonService } from "../services/service-addon-service";
import { ServiceAddon } from "../services/order-types";
import OrderService from "../../order-list/services/order-service";
import { CustomerService } from "../../customer/services/customer-service";
import { isSuccess } from "../../../models/response/base-response";
import { CustomerPricingService, CustomerPricing } from "../../customer-pricing/services/customer-pricing-service";
import ServiceGrid from "../components/ServiceGrid";
import AddonsGrid from "../components/AddonGrid";
import { IS_DEBIT, PAYMENT_METHOD } from "../../order-list/services/order-service";
import useDebounce from "../../../hooks/useDebounce";
// [TẠM TẮT 2026-09] PickupStaffSelect (gán NV lấy hàng khi tạo đơn) — bật lại cùng block bên dưới.
import { PickupStaff } from "../../../components/custom/pickup-staff-select";
import SelectDropdownAsyncPaginate from "../../../components/custom/select-dropdown-async-paginate";
import VehicleLegPicker from "../../../components/custom/vehicle-leg-picker";
import { ApiConfig, API_USER_ROUTER } from "../../../services/api-config";

interface EmployeeOption {
  id: number;
  name?: string;
  phone?: string;
}

interface OrderItem {
  id: number;
  serviceName: string;
  serviceTypeName?: string;
  unitName?: string; // đơn vị bán: kg · cái · lần (từ service_type_maps)
  qty: number;
  price: number;
  originalPrice: number; // Giá gốc từ danh sách dịch vụ
  type: "service" | "addon";
}
// ==== MOCK CUSTOMERS (sẽ thay API sau) ====
export default function OrderIndexPOSPage() {
  // ==== STATE ==== 
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isDirectOrder = searchParams.get("direct") === "true";

  const [searchTerm, setSearchTerm] = useState("");
  // Tìm dịch vụ
  const [searchService, setSearchService] = useState("");

  // Tìm khách hàng (trong popup)
  const [searchCustomer, setSearchCustomer] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null); 
  const [services, setServices] = useState<any[]>([]);
  const [addons, setAddons] = useState<ServiceAddon[]>([]);
  const [orderItems, setOrderItems] = useState<OrderItem[]>([]);
  const [amount_discount, setDiscount] = useState<number>(0);
  const [discountType, setDiscountType] = useState<"VND" | "%">("VND");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [discountPercent, setDiscountPercent] = useState<number>(0); // % giảm giá theo KH
  const [showDropdown, setShowDropdown] = useState(false); 
  const [manualName, setManualName] = useState("");
  const [manualPhone, setManualPhone] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [orderNote, setOrderNote] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [paymentMethod, setPaymentMethod] = useState<number>(PAYMENT_METHOD.CASH);
  const [debit, setDebit] = useState<number>(IS_DEBIT.NO_DEBIT);
  // Multiple employee selections
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeOption[]>([]);
  const [selectedDeliveries, setSelectedDeliveries] = useState<EmployeeOption[]>([]);
  // [TẠM TẮT 2026-09] Gán NV lấy hàng khi tạo đơn — chuyển sang gán ở form cập nhật.
  // const [selectedPickups, setSelectedPickups] = useState<EmployeeOption[]>([]);
  // const [autoAssignPickup, setAutoAssignPickup] = useState<boolean>(false);
  // const [pickupDriverCount, setPickupDriverCount] = useState<number>(1);
  // (Danh sách NV nhận hàng + số đơn treo đã chuyển vào component PickupStaffSelect)
  const [isPickupLaundry, setIsPickupLaundry] = useState<number>(1);
  // Xe tải đi thẳng theo chiều (null = xe máy) — chọn xe = gán cả đội hình xe (xe-tai-doi-hinh-ky-thuat.md §5).
  const [pickupVehicleId, setPickupVehicleId] = useState<number | null>(null);
  const [deliveryVehicleId, setDeliveryVehicleId] = useState<number | null>(null);
  const [requiresCounting, setRequiresCounting] = useState<number>(0); // KH cần kiểm đếm khi nhận
  const [prefillCountFromLast, setPrefillCountFromLast] = useState<number>(1); // prefill SL form kiểm đếm từ đơn gần nhất (mặc định bật)
  // Giặt lại (khách trả SAU): đơn đứng riêng, có thể chỉ định đơn liên quan + người chịu trách nhiệm
  const [isReWash, setIsReWash] = useState<boolean>(false);
  const [reWashParentCode, setReWashParentCode] = useState<string>("");
  const [reWashResponsible, setReWashResponsible] = useState<PickupStaff[]>([]);
  // Giảm giá đơn giặt lại: 0 = miễn phí, 1 = theo %, 2 = theo số tiền
  const [reWashDiscountType, setReWashDiscountType] = useState<0 | 1 | 2>(0);
  const [reWashDiscountValue, setReWashDiscountValue] = useState<string>("");
  const [scheduled_delivery_at, setScheduledDeliveryAt] = useState<string>("");
  const [pickupWeight, setPickupWeight] = useState<string>("");
  // ==== FETCH HOOKS ====
  const { options: storeOptions, loading: loadingStores } = useStoreOptions();
  const { fetch: fetchServices, loading: loadingServices } =
    ServiceMapService.listActive();
  const { fetch: fetchAddons, loading: loadingAddons } =
    ServiceAddonService.listActive();
  const { fetch: fetchCustomers } = CustomerService.list();
  const { fetch: createOrder, loading: creatingOrder } = OrderService.create();
  const { fetch: fetchOrdersList } = OrderService.list();
  const { fetch: fetchOrderDetail } = OrderService.detail();
  const { fetch: fetchCustomerPricings } = CustomerPricingService.byCustomerBranch();
  const [customerPricings, setCustomerPricings] = useState<CustomerPricing[]>([]);

  // ==== INIT BRANCH ====
  useEffect(() => {
    if (!storeOptions.length) return;
    if (selectedBranchId == null)
      setSelectedBranchId(Number(storeOptions[0].value));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeOptions.length, selectedBranchId]);

  // ==== AUTO OPEN MODAL FOR DIRECT ORDER ====

  // ==== FETCH SERVICES ====
  useEffect(() => {
    if (!selectedBranchId) return;
    let active = true;

    (async () => {
      try {
        const res = await fetchServices({
          status: 1,
          branch_id: selectedBranchId,
          store_id: selectedBranchId,
          limit: 1000, // Fetch all services
        });

        if (!active) return;

        if (res && isSuccess(res)) {
          const list = (res as any)?.data?.list ?? [];

          // Grouping logic
          const groupedServices = new Map<number, any>();

          for (const item of list) {
            // Skip items without valid service data
            if (!item.service || !item.service.id) {
              console.warn('Skipping item with null service:', item);
              continue;
            }

            const serviceId = item.service.id;
            let group = groupedServices.get(serviceId);

            if (!group) {
              group = {
                id: item.service.id,
                name: item.service.name || 'Unknown',
                image_url: item.service.image_url || "",
                variants: [],
              };
              groupedServices.set(serviceId, group);
            }

            // Handle both serviceType and service_type naming
            const serviceTypeName = item.serviceType?.name || item.service_type?.name || 'Mặc định';

            group.variants.push({
              id: item.id, // This is the service_map_id
              name: serviceTypeName,
              price: Number(item.price),
              unitName: item.unit_name || "", // đơn vị bán từ BE
            });
          }

          const normalized = Array.from(groupedServices.values());
          setServices(normalized);

        } else {
          console.error("Lỗi load dịch vụ: response không thành công", res);
          setServices([]);
        }
      } catch (err) {
        console.error("Lỗi load dịch vụ:", err);
        if (active) setServices([]);
      }
    })();

    return () => {
      active = false;
    };
  }, [selectedBranchId]);

  // ==== FETCH CUSTOMERS FOR DROPDOWN ====
  useDebounce(() => {
    if (!showDropdown) return;
    const key_search = searchCustomer.trim();
    if (key_search.length === 0) {
      setCustomerOptions([]);
      return;
    }
    (async () => {
      const res = await fetchCustomers({ key_search: key_search, page: 1, limit: 20 });
      if (res && isSuccess(res)) {
        const dataBlock: any = (res as any).data ?? {};
        const list = Array.isArray(dataBlock.list)
          ? dataBlock.list
          : Array.isArray(dataBlock.data?.list)
          ? dataBlock.data.list
          : [];
        setCustomerOptions(list.map((c: any) => ({
          id: c.id,
          name: c.name,
          phone: c.phone,
          address: c.address,
          discount_percent: Number(c.discount_percent ?? 0),
          default_payment_method: Number(c.default_payment_method ?? 1),
          requires_counting: Number(c.requires_counting ?? 0),
        })));
      } else {
        setCustomerOptions([]);
      }
    })();
  }, 300, [searchCustomer, showDropdown]);

  // ==== FETCH ADDONS ====
  useEffect(() => {
    if (!selectedBranchId) return;
    let active = true;

    (async () => {
      try {
        const res = await fetchAddons({
          status: 1,
          branch_id: selectedBranchId,
          store_id: selectedBranchId,
          limit: 1000, // Fetch all addons
        } as any);
        if (!active) return;
        setAddons((res as any)?.data?.list || []);
      } catch (err) {
        console.error("Lỗi load addons:", err);
        if (active) setAddons([]);
      }
    })();

    return () => {
      active = false;
    };
  }, [selectedBranchId]);

  // ==== SYNC DISCOUNT PERCENT WITH SELECTED CUSTOMER ====
  useEffect(() => {
    setDiscountPercent(Number(selectedCustomer?.discount_percent ?? 0));
  }, [selectedCustomer]);

  // ==== APPLY CUSTOMER PRICING ====
  const applyCustomerPricing = useCallback((items: OrderItem[], pricings: CustomerPricing[]): OrderItem[] => {
    if (!pricings || pricings.length === 0) {
      // Không có giá riêng → reset về giá gốc
      return items.map(item => ({
        ...item,
        price: item.originalPrice
      }));
    }

    // Tạo map giá riêng theo service_type_map_id
    const pricingMap = new Map<number, number>();
    pricings.forEach(p => {
      if (p.status === 1) { // Chỉ áp dụng giá đang active
        const customPrice = Number(p.custom_price);
        // Bỏ qua giá không hợp lệ (NaN) để tránh hiển thị NaN trên UI
        if (!isNaN(customPrice) && customPrice >= 0) {
          pricingMap.set(p.service_type_map_id, customPrice);
        }
      }
    });

    return items.map(item => {
      if (item.type === "service") {
        // Có giá riêng → dùng giá riêng, không có → dùng giá mặc định (giá gốc)
        return {
          ...item,
          price: pricingMap.has(item.id) ? pricingMap.get(item.id)! : item.originalPrice
        };
      }
      // Addon giữ nguyên
      return item;
    });
  }, []);

  // ==== FETCH CUSTOMER PRICING WHEN CUSTOMER IS SELECTED ====
  const handleSelectCustomer = useCallback(async (customer: any) => {
    setSelectedCustomer(customer);
    setSearchCustomer("");
    setShowDropdown(false);

    // Auto-fill phương thức thanh toán mặc định từ khách hàng
    if (customer?.default_payment_method) {
      const defaultPM = Number(customer.default_payment_method);
      setPaymentMethod(defaultPM);
      // Nếu KH mặc định Công nợ → cũng phải set debit=DEBIT (vì select modal không có option CONG_NO,
      // CONG_NO được control qua dropdown "Ghi nợ")
      if (defaultPM === PAYMENT_METHOD.CONG_NO) {
        setDebit(IS_DEBIT.DEBIT);
      } else {
        setDebit(IS_DEBIT.NO_DEBIT);
      }
    }

    // Auto-fill nhu cầu kiểm đếm mặc định từ khách hàng (có thể chỉnh lại)
    setRequiresCounting(Number(customer?.requires_counting) === 1 ? 1 : 0);

    if (customer?.id && selectedBranchId) {
      try {
        // Lấy giá riêng CHỈ theo chi nhánh hiện tại (tránh lấy giá từ chi nhánh khác gây NaN)
        const res = await fetchCustomerPricings(customer.id, selectedBranchId);
        if (res && isSuccess(res)) {
          const pricings = Array.isArray((res as any)?.data?.list ?? (res as any)?.data) ? ((res as any)?.data?.list ?? (res as any)?.data) : [];
          setCustomerPricings(pricings);

          if (pricings.length > 0) {
            // Áp dụng giá riêng cho các item đã chọn
            if (orderItems.length > 0) {
              const updatedItems = applyCustomerPricing(orderItems, pricings);
              const hasChangedPrice = updatedItems.some((item, index) => item.price !== orderItems[index].price);

              if (hasChangedPrice) {
                setOrderItems(updatedItems);
                showToast({ message: "Đã cập nhật giá riêng cho khách hàng", type: "success" });
              }
            } else {
              // Auto-populate logic for direct order when customer pricing exists
              const autoItems: OrderItem[] = [];
              pricings.forEach((p: any) => {
                if (p.status !== 1) return;
                for (const group of services) {
                  const variant = group.variants.find((v: any) => v.id === p.service_type_map_id);
                  if (variant) {
                    autoItems.push({
                      id: variant.id,
                      serviceName: group.name,
                      serviceTypeName: variant.name,
                      unitName: variant.unitName || "",
                      qty: 0, // Default to 0 khi nạp danh sách
                      price: Number(p.custom_price),
                      originalPrice: variant.price,
                      type: "service",
                    });
                    break;
                  }
                }
              });
              if (autoItems.length > 0) {
                setOrderItems(autoItems);
                showToast({ message: "Đã tải sản phẩm từ cấu hình bảng giá riêng", type: "success" });
              }
            }
          } else {
            // Fallback: Fetch latest order
            if (customer?.id) {
              fetchOrdersList({ customer_id: customer.id, limit: 1 }).then(listRes => {
                const listData = (listRes as any)?.data?.list ?? (listRes as any)?.data ?? [];
                if (listData.length > 0) {
                  const lastOrderId = listData[0].id;
                  fetchOrderDetail(lastOrderId).then(detailRes => {
                    const detailData = (detailRes as any)?.data;
                    if (detailData && detailData.items && detailData.items.length > 0) {
                      const fallbackItems = detailData.items.map((it: any) => ({
                        id: Number(it.item_id),
                        serviceName: it.item_name || `#${it.item_id}`,
                        serviceTypeName: "",
                        unitName: it.unit_name || "",
                        qty: 0,
                        price: Number(it.price) || 0,
                        originalPrice: Number(it.price) || 0,
                        type: Number(it.item_type) === 2 ? "addon" : "service",
                      }));
                      setOrderItems(fallbackItems);
                      showToast({ message: "Đã tải sản phẩm từ đơn hàng gần nhất", type: "success" });
                    }
                  });
                }
              });
            }
          }
        } else {
          setCustomerPricings([]);
        }
      } catch (err) {
        console.error("Lỗi lấy giá riêng khách hàng:", err);
        setCustomerPricings([]);
      }
    } else {
      setCustomerPricings([]);
      // Reset giá về giá gốc nếu bỏ chọn khách hàng
      if (orderItems.length > 0) {
        setOrderItems(prev => prev.map(item => ({
          ...item,
          price: item.originalPrice
        })));
      }
    }
  }, [fetchCustomerPricings, selectedBranchId, orderItems, applyCustomerPricing, services, fetchOrdersList, fetchOrderDetail]);

  // ==== CLEAR CUSTOMER ====
  const handleClearCustomer = useCallback(() => {
    setSelectedCustomer(null);
    setCustomerPricings([]);
    setPaymentMethod(PAYMENT_METHOD.CASH); // Reset về tiền mặt khi bỏ chọn KH
    setDebit(IS_DEBIT.NO_DEBIT);
    // Reset giá về giá gốc
    if (orderItems.length > 0) {
      setOrderItems(prev => prev.map(item => ({
        ...item,
        price: item.originalPrice
      })));
      showToast({ message: "Đã khôi phục giá gốc", type: "info" });
    }
  }, [orderItems.length]);

  // ==== ADD TO CART ====
  const handleAddService = (svc: any, variant: any) => {
    setOrderItems((prev) => {
      const exists = prev.find(
        (it) => it.id === variant.id && it.type === "service"
      );
      if (exists) {
        return prev.map((it) =>
          it.id === variant.id && it.type === "service"
            ? { ...it, qty: it.qty + 1 }
            : it
        );
      }

      // Kiểm tra xem có giá riêng cho sản phẩm này không
      const customPricing = customerPricings.find(
        p => p.service_type_map_id === variant.id && p.status === 1
      );
      const finalPrice = customPricing ? (Number(customPricing.custom_price) || variant.price) : variant.price;

      return [
        ...prev,
        {
          id: variant.id,
          serviceName: svc.name,
          serviceTypeName: variant.name,
          unitName: variant.unitName || "",
          qty: 1,
          price: finalPrice,
          originalPrice: variant.price, // Luôn lưu giá gốc
          type: "service",
        },
      ];
    });
  };

  const handleAddAddon = (addon: ServiceAddon) => {
    setOrderItems((prev) => {
      const hasService = prev.some((it) => it.type === "service");
      if (!hasService) {
        alert(" Vui lòng chọn dịch vụ giặt ủi trước khi thêm dịch vụ thêm!");
        return prev;
      }

      // Nếu có dịch vụ chính rồi thì thêm bình thường
      const exists = prev.find((it) => it.id === addon.id && it.type === "addon");
      if (exists) {
        return prev.map((it) =>
          it.id === addon.id && it.type === "addon"
            ? { ...it, qty: it.qty + 1 }
            : it
        );
      }

      return [
        ...prev,
        {
          id: addon.id,
          serviceName: addon.name,
          qty: 1,
          price: addon.price,
          originalPrice: addon.price, // Addon không có giá riêng, giữ nguyên
          type: "addon",
        },
      ];
    });
  };

  // ==== CALC (với NaN safety) ====
  const subTotal = orderItems
    .filter((i) => i.type === "service")
    .reduce((sum, i) => sum + i.qty * (Number(i.price) || 0), 0);

  const addonTotal = orderItems
    .filter((i) => i.type === "addon")
    .reduce((sum, i) => sum + i.qty * (Number(i.price) || 0), 0);


  const percentDiscountAmount = Math.max(
    0,
    Math.floor(((subTotal + addonTotal) * (discountPercent || 0)) / 100)
  );
  const finalTotal = Math.max(0, subTotal + addonTotal - percentDiscountAmount - (amount_discount || 0));
  // ==== UI ====
  return (
    <div className="flex flex-col lg:flex-row h-screen w-full bg-gray-100">
      {/* ==== LEFT PANEL (Service Selection) ==== */}
      <div className="flex-1 p-4 md:p-6 w-full lg:w-3/5 overflow-y-auto">
        {/* Search + Branch */}
        <div className="flex flex-col md:flex-row items-center gap-4 mb-6">
          <input
            type="text"
            placeholder="Tìm dịch vụ..."
            value={searchService}
            onChange={(e) => setSearchService(e.target.value)}
            className="flex-1 border rounded-lg px-4 py-2 shadow-sm focus:outline-none text-base"
          />
          <select
            value={selectedBranchId != null ? String(selectedBranchId) : ""}
            onChange={(e) => {
              const newBranchId = e.target.value ? Number(e.target.value) : null;

              if (newBranchId !== selectedBranchId) {
                if (orderItems.length > 0) {
                  showToast({ message: "Giỏ hàng đã được làm mới do đổi chi nhánh", type: "warning" });
                }

                setSelectedBranchId(newBranchId);
                setOrderItems([]);
                setDiscount(0);
                setDiscountType("VND");
                // Reset customer pricing khi đổi chi nhánh
                setCustomerPricings([]);
              }
            }}
            className="border rounded-lg px-3 py-2 shadow-sm focus:outline-none text-base"
            disabled={loadingStores || storeOptions.length === 0}
          >
            <option value="">-- Chọn chi nhánh --</option>
            {storeOptions.map((option) => (
              <option key={option.value} value={String(option.value)}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Dịch vụ chính */}
        <ServiceGrid
          loadingServices={loadingServices}
          services={services}
          searchTerm={searchService}
          addToOrder={handleAddService}
        />

        {/* Dịch vụ thêm */}
        <AddonsGrid
          addons={addons}
          loadingAddons={loadingAddons}
          setOrderAddons={(cb: any) => setOrderItems((prev) => cb(prev))}
          disabled={orderItems.every((it) => it.type !== "service")} 
        />
      </div>

      {/* ==== RIGHT PANEL (Cart) ==== */}
      <div className="w-full lg:w-2/5 bg-white shadow-lg p-4 md:p-6 flex flex-col overflow-y-auto">
        <h3 className="text-lg font-semibold border-b pb-3 mb-4">🧺 Giỏ hàng</h3>

        {orderItems.length === 0 ? (
          <div className="text-center text-gray-500 py-10">
            Chưa có sản phẩm
          </div>
        ) : (
          <>
            {/* === DỊCH VỤ CHÍNH === */}
            {orderItems.some((i) => i.type === "service") && (
              <div className="mb-6">
                <h4 className="font-semibold text-gray-700 mb-2">
                  Dịch vụ chính
                </h4>
                <table className="w-full border border-gray-200 text-sm">
                  <thead className="bg-gray-100 text-gray-600">
                    <tr>
                      <th className="py-2 px-2 text-left">Tên dịch vụ</th>
                      <th className="py-2 px-2 text-left">Loại</th>
                      <th className="py-2 px-2 text-center">SL</th>
                      <th className="py-2 px-2 text-right">Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems
                      .filter((it) => it.type === "service")
                      .map((item) => (
                        <tr key={`svc-${item.id}`} className="border-t">
                          <td className="py-2 px-2 font-medium text-gray-800">
                            {item.serviceName}
                          </td>
                          <td className="py-2 px-2 text-gray-500">
                            {item.serviceTypeName}
                            {item.unitName && (
                              <span className="block text-xs text-blue-600">
                                ĐVT: {item.unitName}
                              </span>
                            )}
                          </td>
                          <td className="py-2 px-2 text-center">
                            <div className="flex items-center justify-center gap-1">
                              <button
                                onClick={() =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: Math.max(0, it.qty - 1) }
                                        : it
                                    )
                                  )
                                }
                                className="px-2 border rounded hover:bg-gray-100"
                              >
                                –
                              </button>

                              <input
                                type="number"
                                value={item.qty}
                                min={0}
                                onChange={(e) =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: Math.max(0, Number(e.target.value)) }
                                        : it
                                    )
                                  )
                                }
                                className="w-12 text-center border rounded"
                              />

                              <button
                                onClick={() =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: it.qty + 1 }
                                        : it
                                    )
                                  )
                                }
                                className="px-2 border rounded hover:bg-gray-100"
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td className="py-2 px-2 text-right font-medium">
                            <div>
                              {(item.qty * (Number(item.price) || 0)).toLocaleString("vi-VN")}₫
                              {item.price !== item.originalPrice && (
                                <span className="block text-xs text-green-600">
                                  (Giá riêng)
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="flex justify-between font-semibold mt-2 border-t pt-2">
                  <span>Tổng dịch vụ</span>
                  <span>{subTotal.toLocaleString("vi-VN")}₫</span>
                </div>
              </div>
            )}

            {/* === DỊCH VỤ THÊM === */}
            {orderItems.some((i) => i.type === "addon") && (
              <div className="mb-6">
                <h4 className="font-semibold text-gray-700 mb-2">
                  Dịch vụ thêm
                </h4>
                <table className="w-full border border-gray-200 text-sm">
                  <thead className="bg-gray-100 text-gray-600">
                    <tr>
                      <th className="py-2 px-2 text-left">Tên dịch vụ</th>
                      <th className="py-2 px-2 text-center">SL</th>
                      <th className="py-2 px-2 text-right">Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems
                      .filter((it) => it.type === "addon")
                      .map((item) => (
                        <tr key={`addon-${item.id}`} className="border-t">
                          <td className="py-2 px-2 font-medium text-gray-800">
                            {item.serviceName}
                          </td>
                          <td className="py-2 px-2 text-center">
                            <div className="flex items-center justify-center gap-1">
                              <button
                                onClick={() =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: Math.max(0, it.qty - 1) }
                                        : it
                                    )
                                  )
                                }
                                className="px-2 border rounded hover:bg-gray-100"
                              >
                                –
                              </button>

                              <input
                                type="number"
                                value={item.qty}
                                min={0}
                                onChange={(e) =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: Math.max(0, Number(e.target.value)) }
                                        : it
                                    )
                                  )
                                }
                                className="w-12 text-center border rounded"
                              />

                              <button
                                onClick={() =>
                                  setOrderItems((prev) =>
                                    prev.map((it) =>
                                      it.id === item.id && it.type === item.type
                                        ? { ...it, qty: it.qty + 1 }
                                        : it
                                    )
                                  )
                                }
                                className="px-2 border rounded hover:bg-gray-100"
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td className="py-2 px-2 text-right font-medium">
                            {(item.qty * item.price).toLocaleString("vi-VN")}₫
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="flex justify-between font-semibold mt-2 border-t pt-2">
                  <span>Tổng dịch vụ thêm</span>
                  <span>{addonTotal.toLocaleString("vi-VN")}₫</span>
                </div>
              </div>
            )}
          </>
        )}

        {/* === TỔNG CỘNG === */}
        <div className="mt-6 space-y-2 text-base border-t pt-3">
          <div className="flex justify-between">
            <span>Tạm tính:</span>
            <span>{(subTotal + addonTotal).toLocaleString("vi-VN")}₫</span>
          </div>

          {discountPercent > 0 && (
            <div className="flex justify-between items-center">
              <span>
                Giảm giá KH (%): {discountPercent}%
              </span>
              <span>-{percentDiscountAmount.toLocaleString("vi-VN")}₫</span>
            </div>
          )}

          <div className="flex justify-between items-center">
            <span>Giảm giá (VND):</span>
            <input
              type="text"
              inputMode="numeric"
              value={amount_discount.toLocaleString("vi-VN")}
              onChange={(e) => {
                const raw = e.target.value.replace(/[.,\s]/g, "");
                const num = Number(raw) || 0;
                setDiscount(num);
              }}
              placeholder="Nhập số tiền giảm"
              className="w-28 border rounded px-2 py-1 text-right"
            />
          </div>

          <div className="flex justify-between font-bold text-lg pt-3 border-t">
            <span>Thành tiền:</span>
            <span className="text-green-600">
              {finalTotal.toLocaleString("vi-VN")}₫
            </span>
          </div>
        </div>

        {/* === BUTTONS === */}
        <div className="mt-6 flex flex-col gap-3">
          <button
            onClick={() => setShowPaymentModal(true)}
            disabled={orderItems.length === 0}
            className={`w-full font-semibold py-3 rounded transition ${
              orderItems.length === 0
                ? "bg-green-400 cursor-not-allowed opacity-50"
                : "bg-green-500 hover:bg-green-600 text-white"
            }`}
          >
            Xác nhận →
          </button>

          <button
            onClick={() => setOrderItems([])}
            disabled={orderItems.length === 0}
            className={`w-full font-semibold py-3 rounded transition ${
              orderItems.length === 0
                ? "bg-orange-400 cursor-not-allowed opacity-50"
                : "bg-orange-500 hover:bg-orange-600 text-white"
            }`}
          >
            Xóa tất cả
          </button>
        </div>

        {/* === PAYMENT MODAL === */}
        {showPaymentModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-4/5 max-w-6xl rounded-xl shadow-lg p-6 relative overflow-y-auto max-h-[90vh]">
      <button
        onClick={() => setShowPaymentModal(false)}
        className="absolute top-3 right-4 text-gray-500 hover:text-gray-700 text-xl"
      >
        ×
      </button>

      <h2 className="text-xl font-bold text-green-600 mb-4">
        📦 Xác nhận đơn hàng
      </h2>

      {/* --- Layout 2 cột (trên desktop) --- */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* === CỘT TRÁI - THÔNG TIN KHÁCH HÀNG === */}
      <div className="border rounded-xl p-4 bg-gray-50 relative">
        <h3 className="font-semibold text-green-600 mb-3">
          THÔNG TIN KHÁCH HÀNG
        </h3>
        {/* === Hiển thị chi nhánh (readonly) === */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chi nhánh
          </label>
          <select
            value={selectedBranchId != null ? String(selectedBranchId) : ""}
            onChange={(e) => {
              const newBranchId = e.target.value ? Number(e.target.value) : null;
              setSelectedBranchId(newBranchId);
              // Reset cart/customer when changing branch
              setOrderItems([]);
              setSelectedCustomer(null);
            }}
            className="w-full border rounded-lg px-3 py-2 bg-white text-gray-700 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            disabled={storeOptions.length === 0}
          >
            {storeOptions.length === 0 && (
              <option value="">Chưa chọn chi nhánh</option>
            )}
            {storeOptions.map((opt) => (
              <option key={opt.value} value={String(opt.value)}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        {/* === Autocomplete tìm khách hàng === */}
        <div className="mb-3 relative">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Khách hàng (tìm nhanh)
          </label>

          <div className="relative">
            <input
              type="text"
              placeholder="Nhập tên hoặc SĐT khách hàng..."
              value={
                selectedCustomer
                  ? `${selectedCustomer.name} (${selectedCustomer.phone})`
                  : searchCustomer
              }
              onChange={(e) => {
                setSearchCustomer(e.target.value);
                setSelectedCustomer(null);
                setShowDropdown(true);
              }}
              onFocus={() => setShowDropdown(true)}
              className="w-full border rounded-lg px-3 py-2 shadow-sm focus:outline-none focus:ring focus:ring-green-300 pr-8"
            />

            {/* ❌ Nút xoá khách hàng */}
            {selectedCustomer && (
              <button
                onClick={handleClearCustomer}
                className="absolute top-1/2 -translate-y-1/2 right-2 text-gray-400 hover:text-red-500"
                title="Xóa khách hàng"
              >
                ×
              </button>
            )}
          </div>

          {/* Dropdown danh sách khách hàng */}
          {showDropdown && searchCustomer && !selectedCustomer && (
            <div className="absolute z-50 bg-white border rounded-lg shadow-lg mt-1 w-full max-h-56 overflow-auto customer-dropdown">
              {customerOptions.map((c) => (
                  <div
                    key={c.id}
                    className="p-3 hover:bg-green-100 cursor-pointer text-sm transition"
                    onClick={() => handleSelectCustomer(c)}
                  >
                    <div className="font-semibold text-gray-800">{c.name}</div>
                    <div className="text-gray-500">{c.phone}</div>
                    <div className="text-gray-400 italic text-xs">{c.address}</div>
                  </div>
                ))}
            </div>
          )}
        </div>

        {/* === Chọn đến lấy hàng (pickup) === */}
        <div className="mb-3">
          <label className="inline-flex items-center gap-2">
            <input
              type="checkbox"
              className="h-5 w-5 text-green-600"
              checked={isPickupLaundry === 1}
              onChange={(e) => setIsPickupLaundry(e.target.checked ? 1 : 0)}
            />
            <span className="text-sm text-gray-700">Đến lấy hàng Giặt</span>
          </label>
        </div>

        {/* === Kiểm đếm khi nhận (với khách) === */}
        {/* Đã bỏ checkbox "lấy SL từ đơn gần nhất" — BE hard default LUÔN bật. */}
        <div className="mb-3 flex flex-col gap-2">
          <label className="inline-flex items-center gap-2">
            <input
              type="checkbox"
              className="h-5 w-5 text-green-600"
              checked={requiresCounting === 1}
              onChange={(e) => setRequiresCounting(e.target.checked ? 1 : 0)}
            />
            <span className="text-sm text-gray-700">Yêu cầu kiểm đếm khi nhận (với khách)</span>
          </label>
        </div>

        {/* === Giặt lại (khách trả SAU — đơn đứng riêng) === */}
        <div className="border border-orange-200 rounded-lg bg-orange-50/40 p-4 space-y-3 mb-5">
          <label className="inline-flex items-center gap-2">
            <input
              type="checkbox"
              className="h-5 w-5 text-orange-600"
              checked={isReWash}
              onChange={(e) => setIsReWash(e.target.checked)}
            />
            <span className="text-sm font-medium text-orange-700">Đơn giặt lại (khách trả sau)</span>
          </label>
          {isReWash && (
            <div className="space-y-3 pl-1">
              <p className="text-xs text-slate-500">
                Tổng tiền tính theo <b>số ký cân cuối</b> của đơn giặt lại — chọn cách thu tiền bên dưới (deal với khách).
              </p>

              {/* Cách thu tiền (0đ / % / số tiền) */}
              <div>
                <label className="text-sm text-gray-700 block mb-1">Cách thu tiền</label>
                <div className="flex flex-col gap-1.5 text-sm">
                  {([
                    { v: 0, label: "Đơn 0 đồng (miễn phí)" },
                    { v: 1, label: "Giảm theo % tổng bill" },
                    { v: 2, label: "Giảm theo số tiền" },
                  ] as const).map((opt) => (
                    <label key={opt.v} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="pos-rewash-discount"
                        checked={reWashDiscountType === opt.v}
                        onChange={() => { setReWashDiscountType(opt.v); setReWashDiscountValue(""); }}
                      />
                      <span>{opt.label}</span>
                    </label>
                  ))}
                </div>
                {reWashDiscountType !== 0 && (
                  <div className="mt-2 flex items-center gap-2">
                    <input
                      type="text"
                      inputMode="numeric"
                      className="w-40 border rounded-lg px-3 py-1.5 text-sm focus:ring-2 focus:ring-orange-300 focus:outline-none"
                      placeholder={reWashDiscountType === 1 ? "Nhập %" : "Nhập số tiền"}
                      value={reWashDiscountValue}
                      onChange={(e) => {
                        const d = e.target.value.replace(/\D/g, "");
                        if (reWashDiscountType === 1) {
                          setReWashDiscountValue(d ? String(Math.min(Number(d), 100)) : "");
                        } else {
                          setReWashDiscountValue(d ? Number(d).toLocaleString("vi-VN") : "");
                        }
                      }}
                    />
                    <span className="text-sm text-slate-500">{reWashDiscountType === 1 ? "%" : "đ"}</span>
                  </div>
                )}
              </div>

              <div>
                <label className="text-sm text-gray-700 block mb-1">
                  Đơn liên quan <span className="text-slate-400">(tùy chọn — nhập mã đơn gốc, hệ thống sẽ kiểm tra)</span>
                </label>
                <input
                  type="text"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-300 focus:outline-none"
                  placeholder="VD: OD1001 (để trống nếu không xác định)"
                  value={reWashParentCode}
                  onChange={(e) => setReWashParentCode(e.target.value)}
                />
              </div>
              <div>
                <label className="text-sm text-gray-700 block mb-1">
                  Nhân sự chịu trách nhiệm <span className="text-slate-400">(tùy chọn)</span>
                </label>
                <SelectDropdownAsyncPaginate<PickupStaff>
                  key={`rewash-resp-${selectedBranchId || "all"}`}
                  url={`${API_USER_ROUTER.API_LIST}`}
                  projectId={ApiConfig.PROJECT_ID.USER_SERVICE}
                  placeholder={selectedBranchId ? "Chọn nhân sự chịu trách nhiệm..." : "Chọn chi nhánh trước"}
                  isMulti
                  disabled={!selectedBranchId}
                  defaultOptions={reWashResponsible}
                  onChange={(selected) => setReWashResponsible(selected as PickupStaff[])}
                  labelOption="name"
                  classNames="w-full"
                  params={{ status: 1, branch_id: selectedBranchId || undefined }}
                />
              </div>
            </div>
          )}
        </div>

        {/* === Form thông tin khách hàng === */}
        <div className="border rounded-lg bg-white p-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm text-gray-500">Họ và tên</label>
              <input
                type="text"
                value={
                  selectedCustomer ? selectedCustomer.name : manualName
                }
                onChange={(e) => setManualName(e.target.value)}
                readOnly={!!selectedCustomer}
                placeholder="Nhập tên khách hàng"
                className={`w-full border rounded px-3 py-2 ${
                  selectedCustomer
                    ? "bg-gray-100 text-gray-600"
                    : "bg-white text-gray-800"
                }`}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-500">Số điện thoại</label>
              <input
                type="text"
                value={
                  selectedCustomer ? selectedCustomer.phone : manualPhone
                }
                onChange={(e) => setManualPhone(e.target.value)}
                readOnly={!!selectedCustomer}
                placeholder="Nhập số điện thoại"
                className={`w-full border rounded px-3 py-2 ${
                  selectedCustomer
                    ? "bg-gray-100 text-gray-600"
                    : "bg-white text-gray-800"
                }`}
              />
            </div>
          </div>

          <div className="mt-3">
            <label className="block text-sm text-gray-500">Địa chỉ</label>
            <textarea
              value={
                selectedCustomer ? selectedCustomer.address : manualAddress
              }
              onChange={(e) => setManualAddress(e.target.value)}
              readOnly={!!selectedCustomer}
              placeholder="Nhập địa chỉ khách hàng"
              className={`w-full border rounded px-3 py-2 resize-none ${
                selectedCustomer
                  ? "bg-gray-100 text-gray-600"
                  : "bg-white text-gray-800"
              }`}
            />
          </div>
        </div>

        {/* === Ghi chú & địa chỉ giao hàng === */}
        <div className="mt-4">
          <textarea
            placeholder='Ghi chú (VD: "Phân loại quần áo")'
            className="border rounded w-full px-3 py-2 mt-3 h-20 resize-none"
            value={orderNote}
            onChange={(e) => setOrderNote(e.target.value)}
          />
          <textarea
            placeholder='Địa chỉ giao hàng (nếu khác địa chỉ mặc định)'
            className="border rounded w-full px-3 py-2 mt-3 h-20 resize-none"
            value={shippingAddress}
            onChange={(e) => setShippingAddress(e.target.value)}
          />
        </div>
        {/* === [TẠM TẮT 2026-09] Chỉ định NV Lấy hàng ở form TẠO đơn ===
             Có 2 loại đơn (thường / kiểm đếm) → gán ở đây phải xử lý nhiều nhánh.
             Thống nhất: chỉ gán trong form CẬP NHẬT đơn (OrderUpdateModal). Bỏ cặp dấu chú thích bao quanh để bật lại.
        <div className="mt-4">
          <div className="flex items-center justify-between mb-1">
            <label className="block text-sm font-medium text-gray-700">
              Nhân viên Lấy hàng
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <span className="text-xs text-gray-500">Tự động gán</span>
              <input
                type="checkbox"
                checked={autoAssignPickup}
                onChange={(e) => {
                  setAutoAssignPickup(e.target.checked);
                  if (e.target.checked) setSelectedPickups([]);
                }}
                className="w-4 h-4 accent-blue-500"
              />
            </label>
          </div>
          {autoAssignPickup ? (
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Số NV:</span>
              <input
                type="number"
                min={1}
                max={10}
                value={pickupDriverCount}
                onChange={(e) => setPickupDriverCount(Math.max(1, Number(e.target.value) || 1))}
                className="border border-gray-300 rounded px-2 py-1 text-sm w-20"
              />
              <span className="text-xs text-gray-400">Hệ thống tự gắn tài xế rảnh</span>
            </div>
          ) : (
            <PickupStaffSelect
              branchId={selectedBranchId}
              value={selectedPickups}
              onChange={(selected) => setSelectedPickups(selected)}
            />
          )}
        </div>
        === hết phần đã tắt tạm === */}

        {/* Xe tải đi thẳng theo chiều — chọn xe = gán cả đội hình xe (tài xế + phụ xe) cho chiều đó. */}
        <div className="mt-4 rounded-lg border p-3 space-y-3">
          <h4 className="text-sm font-semibold text-green-800">Phương tiện</h4>
          {isPickupLaundry === 1 && (
            <VehicleLegPicker label="Lấy hàng" value={pickupVehicleId} onChange={(id) => setPickupVehicleId(id)} />
          )}
          <VehicleLegPicker label="Giao hàng" value={deliveryVehicleId} onChange={(id) => setDeliveryVehicleId(id)} />
        </div>

        {/* NV Giặt ủi + Giao hàng: ẩn (gán ở bước chuyển trạng thái) */}

      </div>



        {/* === CỘT PHẢI - DANH SÁCH SẢN PHẨM === */}
        <div className="border rounded-xl p-4 bg-gray-50">
          <h3 className="font-semibold text-green-600 mb-3">
            DANH SÁCH SẢN PHẨM
          </h3>

          <table className="w-full border text-sm mb-4">
            <thead className="bg-green-50 text-green-700">
              <tr>
                <th className="py-2 px-2">Hình ảnh</th>
                <th className="py-2 px-2 text-left">Sản phẩm</th>
                <th className="py-2 px-2 text-center">SL</th>
                <th className="py-2 px-2 text-right">Thành tiền</th>
                <th className="py-2 px-2 text-center">Xóa</th>
              </tr>
            </thead>
            <tbody>
              {orderItems.map((item) => (
                <tr key={`itm-${item.id}`} className="border-t bg-white">
                  <td className="py-2 px-2 text-center">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/11329/11329060.png"
                      alt=""
                      className="w-10 h-10 object-contain mx-auto rounded"
                    />
                  </td>
                  <td className="py-2 px-2">
                    <span className="font-medium text-gray-800">
                      {item.serviceName}
                    </span>
                    {item.serviceTypeName && (
                      <span className="block text-gray-500">
                        {item.serviceTypeName}
                      </span>
                    )}
                    {item.unitName && (
                      <span className="block text-xs text-blue-600">
                        ĐVT: {item.unitName}
                      </span>
                    )}
                  </td>
                  <td className="py-2 px-2 text-center">
                    <div className="flex items-center justify-center gap-1">
                      <button
                        onClick={() =>
                          setOrderItems((prev) =>
                            prev.map((it) =>
                              it.id === item.id
                                ? { ...it, qty: Math.max(0, it.qty - 1) }
                                : it
                            )
                          )
                        }
                        className="px-2 border rounded"
                      >
                        –
                      </button>
                      <input
                        type="number"
                        value={item.qty}
                        onChange={(e) =>
                          setOrderItems((prev) =>
                            prev.map((it) =>
                              it.id === item.id
                                ? {
                                    ...it,
                                    qty: Math.max(0, Number(e.target.value)),
                                  }
                                : it
                            )
                          )
                        }
                        className="w-10 text-center border rounded"
                      />
                      <button
                        onClick={() =>
                          setOrderItems((prev) =>
                            prev.map((it) =>
                              it.id === item.id
                                ? { ...it, qty: it.qty + 1 }
                                : it
                            )
                          )
                        }
                        className="px-2 border rounded"
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td className="py-2 px-2 text-right font-medium">
                    <div>
                      {(item.qty * item.price).toLocaleString("vi-VN")}₫
                      {item.price !== item.originalPrice && (
                        <span className="block text-xs text-green-600">
                          (Giá riêng)
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="py-2 px-2 text-center">
                    <button
                      onClick={() =>
                        setOrderItems((prev) =>
                          prev.filter((it) => it.id !== item.id)
                        )
                      }
                      className="text-red-500 hover:text-red-600"
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Điều chỉnh giá */}
          <div className="mt-4">
            <h4 className="font-semibold text-green-600 mb-2">
              ĐIỀU CHỈNH GIÁ
            </h4>

            <div className="flex items-center justify-between gap-3">
              <label className="text-sm text-gray-600">Giảm giá (tiền)</label>
              <input
                type="text"
                inputMode="numeric"
                className="border rounded w-32 px-2 py-1 text-right"
                value={amount_discount.toLocaleString("vi-VN")}
                onChange={(e) => {
                  const raw = e.target.value.replace(/[.,\s]/g, "");
                  const num = Number(raw) || 0;
                  setDiscount(num);
                }}
                placeholder="0"
              />
            </div>
          </div>


          {/* Tổng tiền */}
          <div className="border-t mt-4 pt-3 text-base space-y-1">
            <div className="flex justify-between">
              <span>Tạm tính:</span>
              <span>{(subTotal + addonTotal).toLocaleString("vi-VN")}₫</span>
            </div>
            {discountPercent > 0 && (
              <div className="flex justify-between">
                <span>Chiết Khấu KH: <strong>{ discountPercent}%</strong></span>
                <span>-{percentDiscountAmount.toLocaleString("vi-VN")}₫</span>
              </div>
            )}
            <div className="flex justify-between">
              <span>Giảm giá:</span>
              <span>-
                {(amount_discount).toLocaleString("vi-VN")}₫
              </span>
            </div>
            <div className="flex justify-between font-bold text-lg border-t pt-2">
              <span>Thành tiền:</span>
              <span className="text-green-600">
                {finalTotal.toLocaleString("vi-VN")}₫
              </span>
            </div>
          </div>
         {/* Chọn loại payment */}
        <div className="flex items-center justify-between border-t border-slate-200 pt-4 mt-4">
          <label className="text-base font-medium text-slate-700">
            Hình thức thanh toán
          </label>

          <select
            className="rounded-lg border border-slate-300 bg-white text-sm text-slate-800 font-medium px-3 py-2 min-w-[160px]
                      focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(Number(e.target.value))}
          >
            <option value={PAYMENT_METHOD.CASH} className="text-green-600 font-semibold">
              Tiền mặt
            </option>
            <option value={PAYMENT_METHOD.QR_CODE} className="text-amber-600 font-semibold">
               Chuyển khoản
            </option>
          </select>
          </div>
         {/* Chọn công nợ */}
        <div className="flex items-center justify-between border-t border-slate-200 pt-4 mt-4">
          <label className="text-base font-medium text-slate-700">
              Ghi nợ
          </label>

          <select
            className="rounded-lg border border-slate-300 bg-white text-sm text-slate-800 font-medium px-3 py-2 min-w-[160px]
                      focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
            value={debit}
            onChange={(e) => {
              const val = Number(e.target.value);
              setDebit(val);
              if (val === IS_DEBIT.DEBIT) {
                setPaymentMethod(PAYMENT_METHOD.CONG_NO);
              } else if (paymentMethod === PAYMENT_METHOD.CONG_NO) {
                setPaymentMethod(PAYMENT_METHOD.CASH);
              }
            }}
          >
            <option value={IS_DEBIT.NO_DEBIT} className="text-green-600 font-semibold">
              Thanh toán ngay
            </option>
            <option value={IS_DEBIT.DEBIT} className="text-amber-600 font-semibold">
               Ghi nợ
            </option>
          </select>
          </div>
        {/* Hẹn giờ giao */}
        <div className="flex items-center justify-between border-t border-slate-200 pt-4 mt-4">
            <label className="text-base font-medium text-slate-700">
                Hẹn giờ giao
            </label>
            <div className="min-w-[160px]">
                <DateInputCustom
                    value={scheduled_delivery_at}
                    onChange={(date) => setScheduledDeliveryAt(date ?? "")}
                    placeholder="Chọn ngày giờ"
                    type="date-time"
                />
            </div>
        </div>
        {/* Số ký khi nhận */}
        <div className="flex items-center justify-between border-t border-slate-200 pt-4 mt-4">
            <label className="text-base font-medium text-slate-700">
                Số ký khi nhận
                <span className="text-xs text-slate-400 ml-2">(cân lần 1)</span>
            </label>
            <div className="min-w-[160px]">
                <input
                    type="number"
                    step="0.1"
                    min="0"
                    value={pickupWeight}
                    onChange={(e) => setPickupWeight(e.target.value)}
                    placeholder="Nhập số ký"
                    className="w-full border rounded-lg px-3 py-2 text-right focus:outline-none focus:ring-2 focus:ring-green-500"
                />
            </div>
        </div>
        </div>
      </div>

      {/* Nút hành động */}
      <div className="flex justify-end gap-4 mt-6 border-t pt-4">
        <button
          onClick={() => setShowPaymentModal(false)}
          className="px-6 py-2 border rounded"
        >
          Hủy
        </button>
        <button
          onClick={async () => {
            if (!selectedBranchId) {
              showToast({ message: "Vui lòng chọn chi nhánh", type: "warning" });
              return;
            }
            if (orderItems.length > 0) {
              const hasService = orderItems.some((i) => i.type === "service");
              if (!hasService) {
                showToast({ message: "Vui lòng chọn ít nhất 1 dịch vụ", type: "warning" });
                return;
              }
            }
            const customerId = selectedCustomer?.id ?? null;
            const baseAddress = selectedCustomer ? selectedCustomer.address : manualAddress;
            const address = shippingAddress.trim() ? shippingAddress.trim() : baseAddress;
            if (!customerId || !address) {
              showToast({ message: "Vui lòng chọn khách hàng và nhập địa chỉ", type: "warning" });
              return;
            }
            const reWashDiscountNum = Number(String(reWashDiscountValue).replace(/\D/g, "")) || 0;
            if (isReWash && reWashDiscountType !== 0) {
              if (!(reWashDiscountNum > 0)) {
                showToast({ message: reWashDiscountType === 1 ? "Nhập % giảm giá đơn giặt lại" : "Nhập số tiền giảm đơn giặt lại", type: "warning" });
                return;
              }
              if (reWashDiscountType === 1 && reWashDiscountNum > 100) {
                showToast({ message: "% giảm giá tối đa 100", type: "warning" });
                return;
              }
            }

            const items = orderItems.map((it) => ({
              item_id: it.id,
              item_type: it.type === "service" ? 1 : 2,
              quantity: it.qty,
            }));

            const formatScheduledDeliveryAt = (dateString: string) => {
                if (!dateString) return null;
                const [datePart, timePart] = dateString.split(' ');
                if (!datePart || !timePart) return null;
                const [day, month, year] = datePart.split('/');
                return `${year}-${month}-${day} ${timePart}:00`;
            };

            const payload: any = {
              branch_id: selectedBranchId,
              customer_id: String(customerId),
              address,
              note: orderNote,
              items,
              amount_discount: amount_discount + percentDiscountAmount,
              discount_type: discountType,
              total_price: finalTotal,
              payment_method: paymentMethod,
              is_debit: debit,
              // [TẠM TẮT 2026-09] Không gán NV lấy hàng khi tạo đơn — gán ở form cập nhật.
              // pickup_driver_ids: autoAssignPickup ? [] : selectedPickups.map(e => e.id),
              // pickup_driver_count: autoAssignPickup ? pickupDriverCount : undefined,
              // NV giặt + giao: gán ở bước chuyển trạng thái
              employee_ids: selectedEmployees.map(e => e.id),
              delivery_driver_ids: selectedDeliveries.map(e => e.id),
              is_pickup_laundry: isPickupLaundry,
              requires_counting: requiresCounting,
              prefill_count_from_last: prefillCountFromLast,
              // Giặt lại (đơn đứng riêng, khách trả sau) — giá theo giá thật, số thu điều chỉnh qua giảm giá
              order_type: isReWash ? 2 : 1,
              ...(isReWash && reWashParentCode.trim() ? { parent_order_code: reWashParentCode.trim() } : {}),
              ...(isReWash && reWashResponsible.length ? { responsible_user_ids: reWashResponsible.map((s) => s.id).join(",") } : {}),
              ...(isReWash ? {
                discount_type: reWashDiscountType,
                discount_value: reWashDiscountType !== 0 ? reWashDiscountNum : 0,
              } : {}),
              scheduled_delivery_at: formatScheduledDeliveryAt(scheduled_delivery_at),
              // Weight (cân lần 1)
              pickup_weight: pickupWeight ? parseFloat(pickupWeight) : undefined,
              // Xe tải đi thẳng theo chiều (BE bỏ qua danh sách tài xế của chiều có xe)
              ...(isPickupLaundry === 1 && pickupVehicleId ? { pickup_vehicle_id: pickupVehicleId } : {}),
              ...(deliveryVehicleId ? { delivery_vehicle_id: deliveryVehicleId } : {}),
            };
            try {
              const res = await createOrder(payload);
              if (res && isSuccess(res)) {
                showToast({ message: "Tạo đơn hàng thành công", type: "success" });
                setShowPaymentModal(false);
                setOrderItems([]);
                setSelectedCustomer(null);
                // Reset multiple employee selections
                setSelectedEmployees([]);
                setSelectedDeliveries([]);
                setManualName("");
                setManualPhone("");
                setManualAddress("");
                setOrderNote("");
                setShippingAddress("");
                setIsPickupLaundry(1);
                setPickupVehicleId(null);
                setDeliveryVehicleId(null);
                setRequiresCounting(0);
                setPrefillCountFromLast(1);
                setIsReWash(false);
                setReWashParentCode("");
                setReWashResponsible([]);
                setReWashDiscountType(0);
                setReWashDiscountValue("");
                setScheduledDeliveryAt("");
                setPickupWeight("");
                setCustomerPricings([]); // Reset giá riêng
              } else {
                showToast({ message: res?.message ?? "Không thể tạo đơn hàng", type: "error" });
              }
            } catch (err) {
              console.error(err);
              showToast({ message: "Có lỗi khi tạo đơn hàng", type: "error" });
            }
          }}
          className="px-8 py-2 bg-green-600 hover:bg-green-700 text-white rounded font-bold"
        >
          XÁC NHẬN ĐƠN HÀNG
        </button>
      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
}